import React, { useMemo } from 'react';

const ColumnHeader = ({ column }) => {
  const sortOrder = useMemo(() => {
    if (column.isSortedDesc === true) return 'desc';
    if (column.isSortedDesc === false) return 'asc';
    return 'none';
  });
  const ariaSort = sortOrder === 'none' ? 'none' : sortOrder === 'asc' ? 'ascending' : 'descending';
  const headerContent = column.Header;
  const sortLabel =
    sortOrder === 'asc'
      ? `${headerContent}, sorted ascending`
      : sortOrder === 'desc'
        ? `${headerContent}, sorted descending`
        : `${headerContent}, not sorted`;

  const columnProps = { ...column.getSortByToggleProps() };
  delete columnProps.title; // prevent tooltips

  const { key, colSpan, role, onClick, style } = column.getHeaderProps(columnProps);

  return (
    <th key={key} colSpan={colSpan} role={role} onClick={onClick} style={style} scope="col" aria-sort={ariaSort}>
      <div>
        <span className={`sort-indicator sorted-${sortOrder}`} aria-hidden="true"></span>
        <button type="button" aria-label={sortLabel}>
          {column.render('Header')}
        </button>
      </div>
    </th>
  );
};

export default ColumnHeader;
